import React from 'react'

const Header = ({ sort, sortOrder, onSortChange, onShowEdit }) => (
    <thead>
        <tr className="license-list license-list--header">
            <th style={{ width: '150px' }} className="license-list license-list--audience pointer" onClick={() => onSortChange('licenseId')}>
                License ID&#160;
                {sort === 'licenseId' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
            {/* 
            <th style={{ width: '200px' }} className="license-list license-list--audience pointer" onClick={() => onSortChange('licenseName')}>
                License&#160;
                {sort === 'licenseName' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
            */}
            <th style={{ width: '500px' }} className="license-list license-list--audience pointer" onClick={() => onSortChange('audienceName')}>
                Audience&#160;
                {sort === 'audienceName' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
            <th className="license-list license-list--partnerid pointer" onClick={() => onSortChange('dmp')}>
                Marketplace&#160;
                {sort === 'dmp' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
            {/* 
            <th style={{ width: '150px' }} className="license-list license-list--partnerid pointer" onClick={() => onSortChange('dmpProductId')}>
                Product&#160;
                {sort === 'dmpProductId' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
            <th style={{ minWidth: '180px' }} className="license-list license-list--partnerid pointer" onClick={() => onSortChange('dmpSegmentId')}>
                Segment ID&#160;
                {sort === 'dmpSegmentId' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
            <th className="license-list license-list--partnerid pointer" onClick={() => onSortChange('dmpClientId')}>
                Seat ID&#160;
                {sort === 'dmpClientId' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
            */}
            <th className="license-list license-list--cpm" onClick={() => onSortChange('cpmCost')}>
                CPM&#160;
                {sort === 'cpmCost' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
            <th className="license-list license-list--size" onClick={() => onSortChange('validUntil')}>
                Valid Until&#160;
                {sort === 'validUntil' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
            <th className="license-list license-list--status" onClick={() => onSortChange('status')}>
                Status&#160;
                {sort === 'status' && <i className={'fa fa-angle-' + (sortOrder === 'asc' ? 'up' : 'down')} />}
            </th>
            {onShowEdit && <th className="license-list license-list--actions">Edit</th>}
        </tr>
    </thead>
)

export default Header
